import React, { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import { LoadingState } from '@components';
import { ProtectedRoute } from '@components/AccessControl';

// Lazy load view components
const MarketingAssets = lazy(() => import('./MarketingAssets').then((module) => ({ default: module.MarketingAssets })));
const PriorProductionDetail = lazy(() => import('./PriorProductionDetail').then((module) => ({ default: module.PriorProductionDetail })));
const ProductionOverviewDetail = lazy(() =>
  import('./ProductionOverviewDetail/AdvisorProductionOverviewDetail').then((module) => ({
    default: module.AdvisorProductionOverviewDetail,
  })),
);

export const ViewRouter = () => (
  <Suspense fallback={<LoadingState />}>
    <Routes>
      <Route path={`marketing-assets`} element={<MarketingAssets />} />
      <Route
        path={`prior-production`}
        element={
          <ProtectedRoute>
            <PriorProductionDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={`deals`}
        element={
          <ProtectedRoute>
            <ProductionOverviewDetail />
          </ProtectedRoute>
        }
      />
    </Routes>
  </Suspense>
);
